import { gql } from "@apollo/client";

export const CREATE_OPEN_INCOME_SHIFT = gql`
 mutation OpenIncomeShift($shiftDate: String) {
  openIncomeShift(shiftDate: $shiftDate) {
    status
    message
  }
}
`;
export const CREATE_CLOSE_INCOME_SHIFT = gql`
mutation CloseIncomeShift($id: ID!) {
  closeIncomeShift(_id: $id) {
    status
    message
  }
}
`;


export const GET_LAST_INCOME_SHIFT = gql`
 query GetLastIncomeShift {
  getLastIncomeShift {
    _id
    shiftDate
    openShiftBy {
      user_id
      imageSrc
      email
      isDisabled
      firstName
      lastName
      latinName
      gender
    }
    isClose
    openTime
    closeTime
    closeShiftBy {
      user_id
      imageSrc
      email
      isDisabled
      firstName
      lastName
      latinName
      gender
    }
    createdAt
  }
}
`;


